'use strict';

(function($) {

    var pluginName = 'kumsalFormElements';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var form = this;

        var Plugin = {
            initSelect2: function (select2) {
                $(select2).select2({
                    language: $('html').attr('lang'),
                });
            },
            initSelectAllSelect2: function (select2) {
                $.fn.select2.amd.require([
                    'select2/utils',
                    'select2/dropdown',
                    'select2/dropdown/attachBody'
                ], function (Utils, Dropdown, AttachBody) {
                    function SelectAll() { }

                    SelectAll.prototype.render = function (decorated) {
                        var $rendered = decorated.call(this);
                        var self = this;

                        var $selectAll = $(
                            '<button type="button" class="btn btn-primary w-100">'+_translation.selectAll+'</button>'
                        );

                        $rendered.find('.select2-dropdown').prepend($selectAll);

                        $selectAll.on('click', function (e) {
                            var $results = $rendered.find('.select2-results__option[aria-selected=false]');

                            // Get all results that aren't selected
                            $results.each(function () {
                                var $result = $(this);

                                // Get the data object for it
                                var data = {
                                    _resultId: $result.data().select2Id,
                                    element: $result[0],
                                    id: $result.data().select2Id.split('-').pop(),
                                };

                                // Trigger the select event
                                self.trigger('select', {
                                    data: data
                                });
                            });

                            self.trigger('close');
                        });

                        return $rendered;
                    };

                    $(select2).select2({
                        language: $('html').attr('lang'),
                        dropdownAdapter: Utils.Decorate(
                            Utils.Decorate(
                                Dropdown,
                                AttachBody
                            ),
                            SelectAll
                        ),
                    });
                });
            },
            initIconSelect2: function (select2) {
                function iformat(icon) {
                    var originalOption = icon.element;
                    return $('<span><i class="select-font-icon ' + $(originalOption).val() + '"></i>' + icon.text + '</span>');
                }
                $(select2).select2({
                    language: $('html').attr('lang'),
                    templateSelection: iformat,
                    templateResult: iformat,
                    allowHtml: true
                });
            },
            initFroala: function(id){
                new FroalaEditor(id, {
                    language: $('html').attr('lang'),
                    attribution: false,
                    toolbarButtons: {
                        'moreText': {
                            'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                        },
                        'moreParagraph': {
                            'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                        },
                        'moreRich': {
                            'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR']
                        },
                        'moreMisc': {
                            'buttons': ['undo', 'redo', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'html', 'help']
                        }
                    },

                    // Change buttons for XS screen.
                    toolbarButtonsXS: [['undo', 'redo'], ['bold', 'italic', 'underline']],
                    heightMin: 200,
                    heightMax: 600,

                    requestHeaders: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },

                    imageUploadParam: 'media',
                    imageUploadURL: _route['admin.froala.store'],
                    imageUploadMethod: 'POST',
                    imageMaxSize: _config.upload_max_filesize,
                    imageAllowedTypes: ['jpeg', 'jpg', 'png', 'gif', 'webp','svg+xml'],

                    fileUploadParam: 'media',
                    fileUploadURL: _route['admin.froala.store'],
                    fileUploadMethod: 'POST',
                    fileMaxSize: _config.upload_max_filesize,
                    fileAllowedTypes: ['*'],

                    videoUploadParam: 'media',
                    videoUploadURL: _route['admin.froala.store'],
                    videoUploadMethod: 'POST',
                    videoMaxSize: _config.upload_max_filesize,
                    videoAllowedTypes: ['mp4', 'webm', 'ogg'],


                    imageManagerPageSize: 20,
                    imageManagerScrollOffset: 20,
                    imageManagerLoadURL: _route['admin.froala.index'],
                    imageManagerLoadMethod: "GET",


                    imageManagerDeleteURL: _route['admin.froala.destroy'],
                    imageManagerDeleteMethod: "POST",
                    imageManagerDeleteParams: {
                        _method: 'DELETE'
                    },
                },function () {
                    if($(id)[0].hasAttribute('readonly'))
                    {
                        this.edit.disableDesign();
                        this.edit.off();
                    }
                });
            },
            initFile: function(file){
                $(file).on('change',function(){
                    var fileName = '';
                    for (var i = 0; i < $(this).get(0).files.length; ++i) {
                        fileName = fileName + $(this).get(0).files[i].name.split(/(\\|\/)/g).pop() + (i != ($(this).get(0).files.length - 1) ? ' || ' : '');
                    }
                    $(this).next('.custom-file-label').addClass("selected").html(fileName);
                });
            },
            initDatePicker: function(datepicker){
                var arrows;
                if (KTUtil.isRTL()) {
                    arrows = {
                        leftArrow: '<i class="la la-angle-right"></i>',
                        rightArrow: '<i class="la la-angle-left"></i>'
                    }
                } else {
                    arrows = {
                        leftArrow: '<i class="la la-angle-left"></i>',
                        rightArrow: '<i class="la la-angle-right"></i>'
                    }
                }

                $(datepicker).datepicker({
                    rtl: KTUtil.isRTL(),
                    todayHighlight: true,
                    templates: arrows,
                    language: moment.locale(),
                    todayBtn: "linked",
                    clearBtn: true,
                    format: 'yyyy-mm-dd'
                })
            },
            initDateTimePicker: function(datetimepicker){
                $(datetimepicker).datetimepicker({
                    todayHighlight: true,
                    autoclose: true,
                    format: 'yyyy-mm-dd hh:ii:ss',
                    language: moment.locale(),
                });
            },
            init: function()
            {
                form.find('.kt-select2.kt-select2-autoinit').each(function () {
                    form.initSelect2(this);
                });

                form.find('.kt-select2.kt-select2-icon-autoinit').each(function () {
                    form.initIconSelect2(this);
                });

                form.find('.kt-select2.kt-select2-selectall-autoinit').each(function () {
                    form.initSelectAllSelect2(this);
                });

                form.find('.custom-file-input-kumsal').each(function () {
                    form.initFile(this);
                });

                form.find('.froala-editor-init').each(function () {
                    form.initFroala('#' + $(this).attr('id'));
                });

                form.find('.input-datepicker').each(function () {
                    form.initDatePicker(this);
                });
                form.find('.input-datetimepicker').each(function () {
                    form.initDateTimePicker(this);
                });

                form.find('.kumsal-panel-auto-init').each(function () {
                    $(this).kumsalPanel();
                });

                return form;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            form[funcName] = func;
        });

        if (!form.isInit){
            form.init();
        }

        return form;
    };

}(jQuery));

$(document).ready(function () {
    $(document).kumsalFormElements();
});